import { createRoute, useEntityUrl } from 'framework/routing';

const EXPENSE_PATH = '/employee-expenses';
const UPLOAD_EXPENSES_SEGMENT = 'upload-expenses';

export const getExpenseListUrl = () => EXPENSE_PATH;

export const getExpenseRouterPath = () => `${EXPENSE_PATH}/*`;

export const useExpenseRoute = () => {
  const routers = createRoute({ listRoute: EXPENSE_PATH });

  return {
    uploadExpensesRoute: `${routers.listRoute}/${UPLOAD_EXPENSES_SEGMENT}`,
    ...routers,
  };
};

export const useExpenseUrl = () => {
  const baseUrls = useEntityUrl({
    baseLink: EXPENSE_PATH,
  });

  return {
    ...baseUrls,
    getUploadExpensesUrl: () => `${baseUrls.getListUrl()}/${UPLOAD_EXPENSES_SEGMENT}`,
  };
};
